export class PageContent {
  id: string;
  heading: string;
  sub_heading: string;
  base_color: string = "#482d7d";
}

export class MediaObj {
  id: string = "testID";
  title: string = "New media item";
  description: string = "New media description";
  date: Date = new Date();
  url: string = "";
  author: string = "unknown";
  posted: boolean = true;
}
